import { LOCATION_CHANGE } from 'connected-react-router'

const initialState = {
  submitting: false,
  successful: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return initialState
    }

    case 'SEND_REVIEW': {
      return {
        ...state,
        submitting: true,
      }
    }

    case 'SEND_REVIEW_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'SEND_REVIEW_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false,
      }
    }

    default: {
      return state
    }
  }
}
